import { render } from "./bms-state-list.vue?vue&type=template&id=04ffa464&scoped=true"
import script from "./bms-state-list.vue?vue&type=script&lang=js"
export * from "./bms-state-list.vue?vue&type=script&lang=js"

import "./bms-state-list.vue?vue&type=style&index=0&id=04ffa464&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ffa464"]])

export default __exports__